/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { ENV_COUNTRY } from '../../hooks/enviroment'


export async function serviceUpdateStock(item, code_internal, pharmacy) {
	return await axios({
		method: 'POST',
		url: `${process.env.REACT_APP_FUNCTION_PRODUCTS_EDIT}/stock/edit/${ENV_COUNTRY}`,
		data: {
			pharmacy,
			products: [
				{
					code_internal: code_internal,
					stock: item,
				},
			],
		},
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				notification.success({
					message: 'Stock actualizado',
					description: `La cantidad de stock de este producto se ha actualizado correctamente`,
				})
			} else {
				notification.error({
					message: response.error,
					description: response.message,
				})
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${process.env.REACT_APP_FUNCTION_PRODUCTS_EDIT}/stock/edit/${ENV_COUNTRY}`,
			})
		})
}

export async function serviceUpdatePrice(item, code_internal, pharmacy) {
	return await axios({
		method: 'POST',
		url: `${process.env.REACT_APP_FUNCTION_PRODUCTS_EDIT}/price/edit/${ENV_COUNTRY}`,
		data: {
			pharmacy,
			products: [
				{
					code_internal: code_internal,
					price: item,
				},
			],
		},
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				notification.success({
					message: 'Precio actualizado',
					description: `El precio de este producto se ha actualizado correctamente`,
				})
			} else {
				notification.error({
					message: response.error,
					description: response.message,
				})
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${process.env.REACT_APP_FUNCTION_PRODUCTS_EDIT}/price/edit/${ENV_COUNTRY}`,
			})
		})
}

